/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext, useMemo, useState } from 'react';

export type ChatHistoryContextValue = {
  messageFocused: string;
  focusMessage(messageId: string): void;
  blurMessage(): void;
};

export const ChatHistoryContext = createContext<ChatHistoryContextValue>({
  messageFocused: '',
  focusMessage: () => {},
  blurMessage: () => {},
});

export type MessageFocusHandler = (messageFocused: string) => void;

export const useChatHistoryContext = (cb?: MessageFocusHandler) => {
  const value = useContext(ChatHistoryContext);

  if (cb && value.messageFocused) {
    cb(value.messageFocused);
  }

  return value;
};

export const useChatHistoryContextValue = () => {
  const [messageFocused, setMessageFocused] = useState('');
  const contextValue = useMemo<ChatHistoryContextValue>(
    () => ({
      messageFocused,
      focusMessage(messageId) {
        setMessageFocused(messageId);
      },
      blurMessage() {
        setMessageFocused('');
      },
    }),
    [messageFocused, setMessageFocused]
  );
  return contextValue;
};
